var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudyResearch = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.047 9.375a3 3 0 0 0 2.121-.879m-2.121.879a3 3 0 0 1-2.121-.879m2.12.879v2.25m2.122-3.129a3 3 0 0 0 .879-2.121m-.879 2.121 1.59 1.591m-.711-3.712a3 3 0 0 0-.879-2.121m.879 2.121h2.25M8.168 4.254a3 3 0 0 0-2.121-.879m2.121.879 1.59-1.591m-3.711.712a3 3 0 0 0-2.121.879m2.12-.879v-2.25m-2.12 3.129a3 3 0 0 0-.88 2.121m.88-2.121L2.335 2.663m.712 3.712a3 3 0 0 0 .879 2.121m-.88-2.121H.797m3.13 2.121-1.591 1.591m3.212-8.962h1m2.859 1.184.707.707m1.184 2.859v1m-1.184 2.859-.707.707m-2.86 1.184h-1m-2.858-1.184-.707-.707M.797 6.875v-1M1.98 3.016l.707-.707M18.146 9.1a6.135 6.135 0 0 1 .315 9.07 6.4 6.4 0 0 1-8.941 0 6.2 6.2 0 0 1-1.558-2.52"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M16.152 11.055a.913.913 0 0 1-1.277 0L13.6 9.801a.877.877 0 0 1 0-1.254l3.832-3.764a.915.915 0 0 1 1.277 0l1.277 1.255a.875.875 0 0 1 0 1.254zM19.168 5.232l2.59-2.592m0 0-1.445-1.445m1.445 1.445 1.445 1.445M5.797 15.646h5.058m-4.27 7.225h13.728m-6.503-2.89v2.89"
})));
export { SvgStudyResearch as ReactComponent };
export default __webpack_public_path__ + "assets/images/studyResearch.svg";